// src/services/marketData/providers/alpaca.provider.ts
import { MarketDataProvider } from '../provider.interface';
import { alpacaService } from '../../alpaca/alpacaService';

export class AlpacaProvider implements MarketDataProvider {
  getName(): string {
    return 'Alpaca';
  }

  async getTimeSeriesDaily(symbol: string): Promise<any> {
    const end = new Date().toISOString();
    const start = new Date(Date.now() - 365 * 24 * 60 * 60 * 1000).toISOString();
    const data = await alpacaService.getHistoricalBars([symbol], '1Day', start, end);
    return data[symbol];
  }

  async getTimeSeriesIntraday(symbol: string, interval: string): Promise<any> {
    const end = new Date().toISOString();
    const start = new Date(Date.now() - 24 * 60 * 60 * 1000).toISOString();
    const data = await alpacaService.getHistoricalBars([symbol], interval, start, end);
    return data[symbol];
  }

  async getQuote(symbol: string): Promise<any> {
    const trade = await alpacaService.getLatestTrade(symbol);
    return {
      symbol,
      price: trade.price,
      size: trade.size,
      timestamp: trade.timestamp
    };
  }
}